import { useEffect, useMemo, useState } from 'react';
import { useChatContext, Avatar } from 'stream-chat-react';
import moment from 'moment'
import Badge from '@mui/material/Badge'

import type { UserResponse } from 'stream-chat';

import type { StreamChatType } from '../../types';
import { useAdminPanelFormState } from './context/AdminPanelFormContext';
import { useSelector } from 'react-redux';
import { ListItem, ListItemAvatar, ListItemText } from '@mui/material';

const ListContainer = (props: { children: React.ReactNode }) => {
  const { children } = props;
  const {errors, createChannelType} = useAdminPanelFormState()
  const showHeading = !createChannelType || createChannelType === 'team';
  return (
    <div className='user-list__container'>
      {showHeading && <h2><span>Channel Members</span></h2>}
      <div className='user-list__header user-list__row'>
        <div className='user-list__column-block'>
          <p>User</p>
        </div>
        <div className='user-list__column--checkbox'>
          <p>Status</p>
        </div>
      </div>
      {children}
    </div>
  );
};

type UserItemProps = {
  index: number;
  user: UserResponse<StreamChatType>;
};


const UserItem = ({ index, user }: UserItemProps) => {
  const { handleMemberSelect } = useAdminPanelFormState();

  const title = user.name || user.id;
  return (
    <label htmlFor={user.id} title={title} className='user-list__row'>
      <div className='user-list__column-block'>
        <ListItem dense  sx={{ paddingLeft: 0, paddingRight: 0 }}>
          <ListItemAvatar>
            <Avatar image={user.image} name={title} size={40}/>
          </ListItemAvatar>
          <ListItemText primary={title} secondary={`Last seen ${moment(user.last_active).calendar()}`} secondaryTypographyProps={{ fontSize: `11px !important` }} />
        </ListItem>
      </div>
      <div className='user-list__column--checkbox'>
        <Badge color={user.online ? 'success' : 'secondary'} variant="dot">
          <p>{user.online ? 'online' : 'offline'}</p>
        </Badge>
      </div>
    </label>
  );
};


type UserListLoadState = 'loading' | 'error' | 'empty';

const LOAD_STATE_NOTIFICATION: Record<UserListLoadState, string> = {
  empty: 'No users found.',
  error: 'Error loading, please refresh and try again.',
  loading: 'Loading users...',
};


export const ChannelUsersList = () => {
  const { client, channel } = useChatContext<StreamChatType>();
  const { createChannelType } = useAdminPanelFormState();
  const [loadState, setLoadState] = useState<UserListLoadState | null>(null);
  const [users, setUsers] = useState<UserResponse<StreamChatType>[] | undefined>();

  const channelMembers = useMemo(() => channel?.state.members
      ? channel?.state.members
      : [],
    [channel?.state?.members],
  );
  return (
    <ListContainer>
      {loadState
        ? <div className='user-list__message'>{LOAD_STATE_NOTIFICATION[loadState]}</div>
        : Object.keys(channelMembers || {}).length && Object.keys(channelMembers).map((user, i) => <UserItem index={i} key={user.id} user={channelMembers[user].user} />)}
    </ListContainer>
  );
};
